<form [formGroup]="form" novalidate autocomplete="off">
  <div class="modal-dialog-header">
    <button
      type="button"
      tabindex="-1"
      class="close float-right"
      data-dismiss="modal"
      aria-label="Close"
      (click)="cancel()"
      title="Close form and discard any changes."
    >
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <h3 mat-dialog-title>Update Last Inventoried Date</h3>
  </div>

  <mat-dialog-content class="modal-dialog-content">
    <fieldset>
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label for="lastInventoriedDate">Last Inventoried Date</label>
          <input formControlName="lastInventoriedDate" type="datetime-local" class="form-control form-control-sm" />
          <small class="form-text text-muted">
            This will update the last inventoried date for {{ data.itemCount }} item(s) in your cart.
          </small>
        </div>
      </div>
    </fieldset>
  </mat-dialog-content>

  <div class="modal-dialog-footer">
    <button type="button" class="btn btn-default float-left btn-sm" (click)="cancel()">
      <i class="far fa-times"></i> Cancel
    </button>
    <div class="float-right">
      <button type="button" (submitIfValid)="save()" [form]="form" class="btn btn-primary btn-sm">
        <fa-icon [icon]="faSave"></fa-icon> Save
      </button>
    </div>
  </div>
</form> 